import { render } from "./CallCreate.vue?vue&type=template&id=8256c7ce"
import script from "./CallCreate.vue?vue&type=script&lang=js"
export * from "./CallCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__